(function(){
  // KAI: mega meni pod postavko "SHOP BY BENEFIT" v glavi strani.
  // Panel se odpre na hover (in na fokus s tipkovnico), klik na samo postavko
  // pelje na stran, klik na ploscico pa na pas te kategorije znotraj strani.
  // Stevila izdelkov spodaj so rocna - ce se kategoriji spremeni nabor, popravi tukaj.
  var _PL = (window.Shopify && Shopify.locale === 'pl');
  var PL_N = {b_gut:'Zdrowie jelit',b_skin:'Skóra',b_energy:'Energia',b_immunity:'Odporność',b_aging:'Zdrowe starzenie się',b_hair:'Zdrowe włosy',b_kids:'Dla dzieci',b_calm:'Spokój i odpoczynek'};
  function plCount(n){ var a=n%10,b=n%100; return n+' '+(n===1?'produkt':((a>=2&&a<=4&&(b<12||b>14))?'produkty':'produktów')); }
  var PAGE = _PL ? '/pl/pages/shop-by-benefit' : '/pages/shop-by-benefit';
  var MINW = 1000;   // pod to sirino se panel ne uporablja (tam dela predal)
  var ID   = 'kai-mm';
  var STY  = 'kai-mm-style';

  var I = {
    gut:'<circle cx="12" cy="12" r="8.6"/><path d="M7.2 10.1c1.6-1.7 3.2-1.7 4.8 0s3.2 1.7 4.8 0"/><path d="M7.2 14.4c1.6-1.7 3.2-1.7 4.8 0s3.2 1.7 4.8 0"/>',
    skin:'<path d="M12 3.4c3.2 3.6 5.4 6.3 5.4 8.9a5.4 5.4 0 0 1-10.8 0c0-2.6 2.2-5.3 5.4-8.9Z"/><path d="M9.6 13.2a2.6 2.6 0 0 0 2.6 2.6"/>',
    energy:'<path d="M13.4 2.8 6.6 13h4.6l-1 8.2L17 11h-4.6l1-8.2Z"/>',
    immunity:'<path d="M12 2.9 4.6 5.6v6.1c0 4.4 3.1 8 7.4 9.4 4.3-1.4 7.4-5 7.4-9.4V5.6L12 2.9Z"/><path d="M9.1 11.8 11.3 14l3.9-3.9"/>',
    aging:'<path d="M7 3.5h10"/><path d="M7 20.5h10"/><path d="M8.1 3.5v2.9c0 1.4.7 2.7 1.9 3.4L12 11l2-1.2c1.2-.7 1.9-2 1.9-3.4V3.5"/><path d="M8.1 20.5v-2.9c0-1.4.7-2.7 1.9-3.4L12 13l2 1.2c1.2.7 1.9 2 1.9 3.4v2.9"/>',
    hair:'<path d="M7.6 3.8c1.5 1.9 1.5 3.8 0 5.7s-1.5 3.8 0 5.7 1.4 2.9.5 4.6"/><path d="M12 3.2c1.7 2.1 1.7 4.2 0 6.3s-1.7 4.2 0 6.3 1.6 3.2.6 5"/><path d="M16.4 3.8c1.5 1.9 1.5 3.8 0 5.7s-1.5 3.8 0 5.7 1.4 2.9.5 4.6"/>',
    kids:'<circle cx="12" cy="12" r="8.6"/><circle cx="9.4" cy="10.3" r=".95" fill="currentColor" stroke="none"/><circle cx="14.6" cy="10.3" r=".95" fill="currentColor" stroke="none"/><path d="M8.5 14.2c.9 1.4 2.1 2.1 3.5 2.1s2.6-.7 3.5-2.1"/>',
    calm:'<path d="M20 14.2A8.4 8.4 0 0 1 9.8 4a8.6 8.6 0 1 0 10.2 10.2Z"/><path d="M16.2 4.4l.7 1.7 1.7.7-1.7.7-.7 1.7-.7-1.7-1.7-.7 1.7-.7.7-1.7Z"/>'
  };

  var ITEMS = [
    ['gut','Gut Health','b_gut',3],
    ['skin','Skin','b_skin',5],
    ['energy','Energy','b_energy',5],
    ['immunity','Immunity','b_immunity',4],
    ['aging','Healthy Aging','b_aging',3],
    ['hair','Healthy Hair','b_hair',3],
    ['kids','Kids','b_kids',1],
    ['calm','Calm & Rest','b_calm',1]
  ];

  function svg(k){
    return '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" '+
           'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+I[k]+'</svg>';
  }

  function injectStyle(){
    if(document.getElementById(STY)) return;
    var s = document.createElement('style'); s.id = STY;
    s.textContent =
      '#kai-mm{position:fixed;left:0;right:0;z-index:40;background:#fff;border-top:1px solid #EFEAE5;'+
        'box-shadow:0 18px 34px -22px rgba(8,9,18,.35);padding:22px 0 26px;opacity:0;visibility:hidden;'+
        'transform:translateY(-6px);transition:opacity .16s ease,transform .16s ease,visibility .16s}'+
      '#kai-mm.on{opacity:1;visibility:visible;transform:none}'+
      '#kai-mm .mm-w{max-width:1240px;margin:0 auto;padding:0 24px}'+
      '#kai-mm .mm-lab{margin:0 0 14px;font-size:10.5px;letter-spacing:.16em;text-transform:uppercase;'+
        'font-weight:700;color:rgb(var(--text-color,110 104 98) / .7)}'+
      '#kai-mm .mm-g{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}'+
      '#kai-mm a.mm-t{display:flex;align-items:center;gap:12px;padding:13px 14px;border-radius:12px;'+
        'text-decoration:none;border:1px solid transparent;transition:background .16s ease,border-color .16s ease}'+
      '#kai-mm a.mm-t:hover,#kai-mm a.mm-t:focus-visible{background:#E3E9EE;border-color:#C6D0DA}'+
      '#kai-mm .mm-i{display:flex;flex-shrink:0;color:#3E4E5C}'+
      '#kai-mm .mm-x{display:flex;flex-direction:column;min-width:0}'+
      '#kai-mm .mm-n{font-size:14.5px;font-weight:700;letter-spacing:-.01em;color:rgb(var(--text-color,8 9 18))}'+
      '#kai-mm .mm-c{font-size:11.5px;color:rgb(var(--text-color,110 104 98) / .75);margin-top:1px}'+
      '.kb-band{scroll-margin-top:120px}'+
      '@media (max-width:'+(MINW-1)+'px){#kai-mm{display:none}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function build(){
    var box = document.createElement('div');
    box.id = ID;
    box.setAttribute('role','group');
    box.setAttribute('aria-label',_PL?'Wybierz według potrzeb':'Shop by benefit');
    var h = '<div class="mm-w"><p class="mm-lab">'+(_PL?'Wybierz według potrzeb':'Shop by benefit')+'</p><div class="mm-g">';
    for(var i=0;i<ITEMS.length;i++){
      var it = ITEMS[i];
      h += '<a class="mm-t" href="'+PAGE+'#kb-'+it[2]+'">'+
             '<span class="mm-i">'+svg(it[0])+'</span>'+
             '<span class="mm-x"><span class="mm-n">'+(_PL?(PL_N[it[2]]||it[1]):it[1])+'</span>'+
             '<span class="mm-c">'+(_PL?plCount(it[3]):(it[3]+(it[3]===1?' product':' products')))+'</span></span></a>';
    }
    box.innerHTML = h + '</div></div>';
    return box;
  }

  function visible(el){
    var r = el.getBoundingClientRect();
    if(!r.width || !r.height) return false;
    var s = getComputedStyle(el);
    return s.visibility !== 'hidden' && s.display !== 'none';
  }

  // Povezavo iscemo po celem dokumentu, ne po prvem elementu s "header" v razredu -
  // Shopify ovije tudi vrstico z obvestili v razred, ki vsebuje besedo "header".
  // Predal (drawer) preskocimo, ker tam menija ne prevzemamo.
  function findLink(){
    var as = document.querySelectorAll('a[href*="/pages/shop-by-benefit"]');
    var best = null, bestTop = 1e9;
    for(var i=0;i<as.length;i++){
      var a = as[i];
      if(a.closest('#'+ID)) continue;
      if(a.closest('[class*="drawer"]')) continue;
      if(!a.closest('header, [class*="header"], nav')) continue;
      if(!visible(a)) continue;
      var t = a.getBoundingClientRect().top;
      if(t > 400) continue;
      if(t < bestTop){ best = a; bestTop = t; }
    }
    return best;
  }

  function boot(){
    var link = findLink();
    if(!link) return false;
    if(link.getAttribute('data-kai-mm') === '1') return true;
    link.setAttribute('data-kai-mm','1');

    injectStyle();
    var panel = document.getElementById(ID);
    if(!panel){ panel = build(); document.body.appendChild(panel); }

    var openT = null, closeT = null;

    // Panel postavimo pod najbolj zunanjega lepljivega prednika (to je glava strani),
    // sicer pod glavo, sicer kar pod samo povezavo.
    function host(){
      var el = link.parentElement, stick = null;
      while(el && el !== document.body){
        var p = getComputedStyle(el).position;
        if(p === 'sticky' || p === 'fixed') stick = el;
        el = el.parentElement;
      }
      return stick || link.closest('header') || link.closest('[class*="header"]') || link;
    }
    function position(){
      var r = host().getBoundingClientRect();
      panel.style.top = Math.max(0, Math.round(r.bottom)) + 'px';
    }
    function open(){
      if(window.innerWidth < MINW) return;
      clearTimeout(closeT);
      openT = setTimeout(function(){ position(); panel.classList.add('on'); }, 60);
    }
    function close(now){
      clearTimeout(openT);
      clearTimeout(closeT);
      closeT = setTimeout(function(){ panel.classList.remove('on'); }, now ? 0 : 180);
    }

    link.addEventListener('mouseenter', open);
    link.addEventListener('mouseleave', function(){ close(); });
    link.addEventListener('focus', open);
    panel.addEventListener('mouseenter', function(){ clearTimeout(closeT); });
    panel.addEventListener('mouseleave', function(){ close(); });
    panel.addEventListener('click', function(){ close(true); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(true); });
    window.addEventListener('scroll', function(){ if(panel.classList.contains('on')) close(true); }, {passive:true});
    window.addEventListener('resize', function(){ close(true); }, {passive:true});
    return true;
  }

  function start(){
    if(boot()) return;
    var n = 0;
    var iv = setInterval(function(){ if(boot() || ++n > 20) clearInterval(iv); }, 300);
  }

  if(document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', function(){ setTimeout(start, 60); });
})();